export default __webpack_public_path__ + "static/krasserstoff-f7b547bdcef86ab2c854becb2fa5f5c1.svg";